// import React from "react";
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import authAxios from "../../components/authAxios"

import { createSearchParams, Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";


import Pagination from '@mui/material/Pagination';

import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import DashboardHeader from "../../components/DashboardHeader";
import { useMediaQuery } from 'react-responsive'
import { Card, CardContent } from "@mui/material";

// import Layout from "../../components/Layout";
import ThreeDotsMenu from "../../components/ThreeDotsMenu";

import { format } from 'date-fns';


// import ProductNew from "./ProductNew";

function Charges() {
    const isMobile = useMediaQuery({ query: '(max-width: 750px)' })
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();
    // const { data, fetchData}  = useAxios();   

    const convertDateTime = (myDateTime) => {
        return format(new Date(myDateTime), 'dd-MM-yyyy HH:mm');
    };

    const { data: charges } = useQuery({
        queryKey: ['charges', page],
        queryFn: async () => {
          const response = await authAxios.get(`/loans/loan-charges/?page=${page}`);
          setPageCount(response.data.page_count)
          return response.data.results
        },
        keepPreviousData : true,
    });

    //Pagination
     const handlePageChange = (event, value) => {
        setPage(value);
    };

     const threeSubMenu = [
        {
            id: 1,
            menu: "View",
            url: "/dashboard/product/",
        }, 
        // {
        //     id: 2,
        //     menu: "Edit",
        //     url: "/customeredit/",
        // }
    ];


    return (
            <div className="dashboard-main">

                <section className="dashboard-content">
                    
                    <DashboardHeader dashboardTitle="Charges" dashboardPreTitle="Loan Components" />
                    <table className="styled-table">
                        <thead>
                            <tr >
                                <th>#</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Trigger</th>
                                <th>Frequency</th>
                                <th>Priority</th>
                                <th>Basis</th>
                                <th>Amount</th>
                                <th></th>
                            </tr>
                        </thead>

                        {charges && charges.map(charge => (

                            <tbody key={charge.id}>
                                <tr>
                                    <td>{charge.id}</td>
                                    <td>{charge.name}</td>
                                    <td>{charge.category_name}</td>
                                    <td>{charge.trigger_event_name}</td>
                                    <td>{charge.frequency_name}</td>
                                    <td>{charge.priority}</td>  
                                    <td>{charge.calculation_basis_name}</td>  
                                    <td>{Number(charge.value).toLocaleString()}</td>
                                    <td className='styled-table-menu'>
                                        <ThreeDotsMenu data={charge} threeSubMenu={threeSubMenu} />
                                    </td>
                                </tr>
                            </tbody>
                        ))}
                        

                    </table>

                    <Pagination 
                        className="custom-mui-pagination"
                        count={pagecount} 
                        page={page} 
                        onChange={handlePageChange} 
                    />
{/* 
                    <Link to="/dashboard/productnew" className="nav-link">
                        <Fab className="fab" color="primary" aria-label="add">
                            <AddIcon />
                        </Fab>
                    </Link> */}

                </section>
            </div>

        // </Layout>


    )
}
export default Charges